module.exports = __webpack_public_path__ + "img/p4_3.929e3181.png";